module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers/client.js
// module id = 603
// module chunks = 0